var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDoctor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 232.294,
    height: 117.438,
    viewBox: "0 0 232.294 117.438",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_38325",
    "data-name": "Group 38325",
    transform: "translate(-574 -430.563)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7112",
    "data-name": "Rectangle 7112",
    width: 232,
    height: 117,
    rx: 5,
    transform: "translate(574 431)",
    fill: "#191bc3",
    opacity: 0.781
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_37380",
    "data-name": "Group 37380",
    transform: "translate(745.504 430.563)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65014",
    "data-name": "Path 65014",
    d: "M2935.331,90.562s-40.513,16.139-12,47.552S2909.5,208,2909.5,208h50.79V90.562Z",
    transform: "translate(-2899.504 -90.562)",
    fill: "#d4a0f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65015",
    "data-name": "Path 65015",
    d: "M2935.331,90.562s-40.513,16.139-12,47.552S2909.5,208,2909.5,208h50.79V90.562Z",
    transform: "translate(-2909.504 -90.562)",
    fill: "#a2a0f5",
    opacity: 0.282
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoctor);
export default __webpack_public_path__ + "static/media/Doctor.8c435cbbc2259f94bf6694e42e4634d5.svg";
export { ForwardRef as ReactComponent };